var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.791 10C15.791 10.1658 15.7252 10.3247 15.608 10.4419C15.4907 10.5592 15.3318 10.625 15.166 10.625H5.16602C5.00026 10.625 4.84128 10.5592 4.72407 10.4419C4.60686 10.3247 4.54102 10.1658 4.54102 10C4.54102 9.83424 4.60686 9.67527 4.72407 9.55806C4.84128 9.44085 5.00026 9.375 5.16602 9.375H15.166C15.3318 9.375 15.4907 9.44085 15.608 9.55806C15.7252 9.67527 15.791 9.83424 15.791 10ZM18.291 5.625H2.04102C1.87526 5.625 1.71628 5.69085 1.59907 5.80806C1.48186 5.92527 1.41602 6.08424 1.41602 6.25C1.41602 6.41576 1.48186 6.57473 1.59907 6.69194C1.71628 6.80915 1.87526 6.875 2.04102 6.875H18.291C18.4568 6.875 18.6157 6.80915 18.733 6.69194C18.8502 6.57473 18.916 6.41576 18.916 6.25C18.916 6.08424 18.8502 5.92527 18.733 5.80806C18.6157 5.69085 18.4568 5.625 18.291 5.625ZM12.041 13.125H8.29102C8.12526 13.125 7.96628 13.1908 7.84907 13.3081C7.73186 13.4253 7.66602 13.5842 7.66602 13.75C7.66602 13.9158 7.73186 14.0747 7.84907 14.1919C7.96628 14.3092 8.12526 14.375 8.29102 14.375H12.041C12.2068 14.375 12.3657 14.3092 12.483 14.1919C12.6002 14.0747 12.666 13.9158 12.666 13.75C12.666 13.5842 12.6002 13.4253 12.483 13.3081C12.3657 13.1908 12.2068 13.125 12.041 13.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.9750966576da5c68ed022b98acc94682.svg";
export { ForwardRef as ReactComponent };